
export default {
  is_widget: false,
  widgetparams: {}
}
